/**
 * @generated SignedSource<<5f012645da2924e6bd484d8fb397278d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SkillResult = "ALMOST_THERE" | "DEMONSTRATED" | "KEEP_LEARNING" | "NOT_STARTED" | "PASSED" | "PLACED_OUT" | "REVIEW" | "%future added value";
export type SkillProgressReportStudentsFilterInput = {
  classIds?: ReadonlyArray<string> | null | undefined;
  gradeLevelIds?: ReadonlyArray<string> | null | undefined;
  isActive?: boolean | null | undefined;
  skillId: string;
  skillResult: SkillResult;
};
export type SkillsProgressReportStudentsQuery$variables = {
  after?: string | null | undefined;
  before?: string | null | undefined;
  filter: SkillProgressReportStudentsFilterInput;
  first?: number | null | undefined;
  last?: number | null | undefined;
  skip?: boolean | null | undefined;
};
export type SkillsProgressReportStudentsQuery$data = {
  readonly skillProgressReportStudents?: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
    }> | null | undefined;
    readonly nodes: ReadonlyArray<{
      readonly firstName: string | null | undefined;
      readonly id: string;
      readonly lastName: string | null | undefined;
      readonly publicUserId: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
      readonly hasPreviousPage: boolean;
      readonly startCursor: string | null | undefined;
    };
  } | null | undefined;
};
export type SkillsProgressReportStudentsQuery = {
  response: SkillsProgressReportStudentsQuery$data;
  variables: SkillsProgressReportStudentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v5 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "skip"
},
v6 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
          },
          {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
          },
          {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
          },
          {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
          },
          {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
          }
        ],
        "concreteType": "StudentConnection",
        "kind": "LinkedField",
        "name": "skillProgressReportStudents",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Student",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "publicUserId",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StudentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SkillsProgressReportStudentsQuery",
    "selections": (v6/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v5/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "SkillsProgressReportStudentsQuery",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "5462c6962187551fbdf7005ce64a20f9",
    "id": null,
    "metadata": {},
    "name": "SkillsProgressReportStudentsQuery",
    "operationKind": "query",
    "text": "query SkillsProgressReportStudentsQuery(\n  $filter: SkillProgressReportStudentsFilterInput!\n  $skip: Boolean = false\n  $first: Int\n  $after: String\n  $last: Int\n  $before: String\n) {\n  skillProgressReportStudents(filter: $filter, first: $first, after: $after, last: $last, before: $before) @skip(if: $skip) {\n    nodes {\n      id\n      firstName\n      lastName\n      publicUserId\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n      hasPreviousPage\n      startCursor\n    }\n    edges {\n      cursor\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bc7af44a825e1fc26f9f0208a9136fde";

export default node;
